// src/pages/Reports/SalesTaxLedger/SalesTaxLedgerSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchSalesTaxLedger } from "./salesTaxLedgerThunk";

const initialState = {
  list: [],
  opening_balance: 0,
  closing_balance: 0,
  loading: false,
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const salesTaxLedgerSlice = createSlice({
  name: "salesTaxLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalesTaxLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSalesTaxLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.list;
        state.opening_balance = action.payload.opening_balance;
        state.closing_balance = action.payload.closing_balance;
        state.totals = action.payload.totals;
      })
      .addCase(fetchSalesTaxLedger.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = salesTaxLedgerSlice.actions;
export default salesTaxLedgerSlice.reducer;
